export default __webpack_public_path__ + "static/media/OK.83e19061.svg";